import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Button, TextInput } from 'components';
import {
  TLocalizationForm,
  TLocalizationFormValues,
} from './LocalizationForm.types';

const LocalizationForm: TLocalizationForm = ({ onSubmit }) => {
  const { handleSubmit, control } = useFormContext<TLocalizationFormValues>();

  const onFormSubmit = (data: TLocalizationFormValues) => {
    onSubmit(data);
  };

  return (
    <div className="admin-form">
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="admin-form__form"
        noValidate
      >
        <div className="admin-form__form-content">
          <div className="admin-form__field">
            <Controller
              name="key"
              control={control}
              render={({ field, fieldState }) => (
                <TextInput
                  label="Name"
                  onChange={field.onChange}
                  value={field.value ?? ''}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
          </div>

          <div className="admin-form__field">
            <Controller
              name="value"
              control={control}
              render={({ field, fieldState }) => (
                <TextInput
                  label="Value"
                  onChange={field.onChange}
                  value={field.value ?? ''}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
          </div>
        </div>

        <div className="admin-form__actions">
          <Button variant="contained" type="submit">
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default LocalizationForm;
